<template>
    <div>
        <div class="multiline-ellipsis">
            <el-tooltip :disabled="!showFullText" placement="top">
                <div slot="content" style="width: 250px;max-height:500px;overflow-y: auto; ">{{text}}</div>
                <div class="overHidden addRela" :style="{maxHeight: (lineHeight*lines)+'px', lineHeight: lineHeight+'px' }">
                    {{ text }}
                    <div class="ab_lase_content" :style="{Height: lineHeight+'px', lineHeight: lineHeight+'px' }" v-show="showFullText">{{ truncatedText }}</div>
                </div>
            </el-tooltip>
            <div ref="ellipsis" class="flag-box" :style="{lineHeight: lineHeight+'px'}">
                {{text}}
            </div>
        </div>
    </div>

</template>

<script>
/**
 * 文字超过两行提示
 * 并对中间添加...
 */
export default {
    props: {
        text: {
            type: String,
            required: true
        },
        lines: {
            type: Number,
            default: 2
        },
        lineHeight: {
            type: Number,
            default: 23
        }
    },
    data() {
        return {
            showFullText: false,
            truncatedText: ''
        };
    },
    computed: {

    },
    watch: {
        'text': {
            handler(n, o){
                this.getTextLeng()
            }
        }
    },
    mounted() {
        this.getTextLeng()
    },
    methods: {
        getTextLeng() {
            const ellipsis = this.$refs.ellipsis;
            if (ellipsis) {
                this.$nextTick(()=>{
                    const lineHeight = this.lineHeight
                    const maxHeight = lineHeight * this.lines;
                    if (ellipsis.scrollHeight > maxHeight) {
                        this.showFullText = true
                        // const truncatedLength = Math.floor(this.text.length * (maxHeight / ellipsis.scrollHeight));   //文本位置取值 偏前
                        this.truncatedText = `.....${this.text.slice(this.text.length - 4)}`;  //文本位置取值 偏后
                        // this.truncatedText = `${this.text.slice(0, 12)}......${this.text.slice(this.text.length - 10)}`;
                    } else {
                        this.showFullText = false
                        this.truncatedText = this.text;
                    }
                })
                // const lineHeight = parseInt(window.getComputedStyle(ellipsis).lineHeight);
            }
        },
    }
};
</script>

<style scoped lang="scss">
.multiline-ellipsis {
    position: relative;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.addRela{
    position: relative;
    .ab_lase_content{
        position: absolute;
        max-width: 80px;
        background-color: rgba(255,255,255,0.9);
        right: 0;
        bottom: 0;
        overflow: hidden;
        text-wrap: nowrap;
    }
}
.overHidden{
    overflow-y: hidden;
}
.flag-box{
    position: absolute;
    opacity: 0;
    visibility: hidden;
    top: -888px;
}

</style>
<style>
.hover-row{
    .ab_lase_content{
        background-color: #F5F7FA !important;
    }
}
</style>
